import { render, staticRenderFns } from "./UpdateIdCard.vue?vue&type=template&id=7df56de2&"
import script from "./UpdateIdCard.vue?vue&type=script&lang=js&"
export * from "./UpdateIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports